import tw from "twin.macro";
import { useQuery } from "@tanstack/react-query";
import some from "lodash.some";

import ProductCardGalllerySearch from "@/components/Molecules/ProductCardGalllerySearch";
import ProductCardGallerySkeleton from "@/components/Atoms/ProductCardGallerySkeleton";
import Card from "@/components/Atoms/Card";
import Heading from "@/components/Atoms/Heading";
import ProductCardGallery from "@/components/Molecules/ProductCardGallery";

import { pulseBridgeToCart } from "@/utils/product";
import { getSimilarProducts } from "@/services/pulseBridge";

import { StyledContentProductsRow } from "./styles";

interface QueryReturnType {
  items: Cart[];
}

const RecomendedVariusProducts = ({
  product,
  storeId,
  items: itemsCheckout,
}: {
  product: Cart;
  storeId: number;
  items: Cart[];
  [key: string]: any;
}) => {
  const { data, isFetching, error } = useQuery<QueryReturnType>({
    queryKey: ["itemOutOfStock", storeId, product.product.id],
    queryFn: async () => {
      const result = await getSimilarProducts(product.product.sku, storeId, 6);
      const outOfStockSkus = new Set(itemsCheckout.map((item) => item.product.sku));
      const items: Cart[] = result.data.data
        .map(pulseBridgeToCart)
        .filter((item) => !some(outOfStockSkus, (sku) => sku === item.product.sku))
        .slice(0, 2);
      return { items };
    },
    enabled: !!storeId && !!product?.product?.id,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });

  return (
    <Card
      classes={{
        root: tw`w-full flex flex-col gap-s shadow-elevation-0 border border-neutral-90`,
      }}
    >
      <ProductCardGalllerySearch item={product} disabled showButtonCart={false} />

      {error !== null || (data && data?.items.length >= 1) ? (
        <Heading type="h6">Mira estas sugerencias</Heading>
      ) : (
        <Heading type="h6">No hay recomendaciones disponibles</Heading>
      )}

      {(isFetching || !storeId || !product.product.id) && (
        <StyledContentProductsRow>
          {Array.from({ length: 2 }).map((_, index) => (
            <ProductCardGallerySkeleton key={index} sizeVariant="sm" orientation="horizontal" />
          ))}
        </StyledContentProductsRow>
      )}

      {data && data.items.length > 1 && (
        <StyledContentProductsRow>
          {data?.items.slice(0, 2).map((item, index) => (
            <ProductCardGallery key={index} sizeVariant="sm" orientation="horizontal" item={item} />
          ))}
        </StyledContentProductsRow>
      )}
    </Card>
  );
};

export default RecomendedVariusProducts;
